import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { ModuleWithProviders, NgModule } from '@angular/core';
import {
  JsonPipe,
  NgForOf,
  NgIf,
  NgSwitch,
  NgSwitchCase,
} from '@angular/common';

import { BreadcrumbsService } from './breadcrumbs.service';
import { BreadcrumbsComponent } from './breadcrumbs.component';

@NgModule({
  exports: [ BreadcrumbsComponent ],
  imports: [
    JsonPipe,
    RouterLink,
    NgForOf,
    TranslateModule,
    NgSwitch,
    NgSwitchCase,
    NgIf,
    BreadcrumbsComponent,
  ],
})
export class BreadcrumbsModule {
  public static forRoot(): ModuleWithProviders<BreadcrumbsModule> {
    return {
      ngModule: BreadcrumbsModule,
      providers: [
        BreadcrumbsService,
      ],
    };
  }
}
